import Vue from "vue";
import axios from 'axios';

const version = 'v1';
const getAllInstanceManagersApi = `${version}/instanceManager/getAll`;
const addInstanceManagersApi = `${version}/instanceManager/add`;
const updateInstanceManagersApi = `${version}/instanceManager/update`;
const deleteInstanceManagersApi = `${version}/instanceManager/delete`;
const EditInstanceApi = `${version}/instanceManager/editInstance`;
const moveInstanceManagersApi = `${version}/instanceManager/moveInstance`;
const addSupportUserApi = `${version}/instanceManager/add-support-user`;
const updateAllCompanies = `${version}/instanceManager/update-all-companies`;
const CheckSubscriptionPaid = `${version}/instanceManager/CheckSubscriptionsPaid`;
export const state = Vue.observable({
    instantManagers: [],
    instanceManagersCount: 0
});

export const mutations = {
    async setInstanceManager(params = {}) {
        var res = await axios.post(getAllInstanceManagersApi, params);
        state.instantManagers = res?.data?.result?.items;
        state.instanceManagersCount = res?.data?.result?.totalCount;
    },
    async addInstanceManager(instanceManager) {
        await axios.post(addInstanceManagersApi, instanceManager);
        await this.setInstanceManager();
    },
    async updateInstanceManager(instanceManager) {
        await axios.put(updateInstanceManagersApi, instanceManager);
        await this.setInstanceManager();
    },
    async deleteInstanceManager(instanceManagerId) {
        await axios.delete(`${deleteInstanceManagersApi}/${instanceManagerId}`);
        await this.setInstanceManager();
    },
	async EditInstance(companyId){
		const response = await axios.get(`${EditInstanceApi}/${companyId}`);
		return response;
	},
    async moveInstance(moveInstance) {
        const response  = await axios.post(moveInstanceManagersApi, moveInstance);
        return response;
    },
    async addSupportUser(addSupportUser) {
        const response  = await axios.post(addSupportUserApi, addSupportUser);
        return response;
    },
    async UpdateAllCompanies() {
        const response  = await axios.put(updateAllCompanies);
        return response;
    },
    async CheckSubscriptionPaid() {
        const response  = await axios.get(CheckSubscriptionPaid);
        return response;
    }
};